import { accountAccessApi } from './accountAccessApi';
import { accountsApi } from './accountsApi';
import { accountSetupApi } from './accountSetupApi';
import { adminInvestorsApi } from './adminInvestorsApi';
import { advisorGroupModuleLocalizationsApi } from './advisorGroupModuleLocalizationsApi';
import { advisorAggregatedHoldingsApi } from './advisorAggregatedHoldingsApi';
import { advisorGroupsApi } from './advisorGroupsApi';
import { advisorInvestorsApi } from './advisorInvestorsApi';
import { aggregatedAccountsApi } from './aggregatedAccountsApi';
import { aggregatorCredentialsApi } from './aggregatorCredentialsApi';
import { cashFlowApi } from './cashFlowApi';
import { classificationsApi } from './classificationsApi';
import { clientActivityApi } from './clientActivityApi';
import { clientsApi } from './clientsApi';
import { colorsApi } from './colorsApi';
import { contactsApi } from './contactsApi';
import { dashboardApi } from './dashboardApi';
import { dashboardMessagesApi } from './dashboardMessagesApi';
import { dataFeedsApi } from './dataFeedsApi';
import { disclaimersApi } from './disclaimersApi';
import { diversificationsApi } from './diversificationsApi';
import { documentsApi } from './documentsApi';
import { eConsentConfigApi } from './eConsentConfigApi';
import { clientInvitationConfigApi } from './clientInvitationConfigApi';
import { clientRelationshipsApi } from './clientRelationshipsApi';
import { errorsApi } from './errorsApi';
import { feedClassificationsApi } from './feedClassificationsApi';
import { financialInstitutionsApi } from './financialInstitutionsApi';
import { firmApi } from './firmApi';
import { gridColumnsApi } from './gridColumnsApi';
import { holdingsApi } from './holdingsApi';
import { homeAwayInstitutionsApi } from './homeAwayInstitutionsApi';
import { insightsApi } from './insightsApi';
import { integrationsApi } from './integrationsApi';
import { masterSearchApi } from './masterSearchApi';
import { mgpApi } from './mgpApi';
import { notificationsApi } from './notificationsApi';
import { pageVisibilityApi } from './pageVisibilityApi';
import { performanceReportsApi } from './performanceReportsApi';
import { permissionsApi } from './permissionsApi';
import { propertyApi } from './propertyApi';
import { quickLinksResourcesApi } from './quickLinksResourcesApi';
import { reportsApi } from './reportsApi';
import { settingsApi } from './settingsApi';
import { setupAccountsApi } from './setupAccountsApi';
import { socialSettingsApi } from './socialSettingsApi';
import { tabsApi } from './tabsApi';
import { teamMembersApi } from './teamMembersApi';
import { termsApi } from './termsApi';
import { transactionsApi } from './transactionsApi';
import { teamMemberApi } from './teamMemberApi';
import { usersApi } from './usersApi';
import { wealthsApi } from './wealthsApi';
import { yodleeApi } from './yodleeApi';

/**
 * Canonical list of RTK Query API slices that hold user-specific data.
 *
 * This is every API slice registered in `store.ts` EXCEPT `authApi` and
 * `appViewApi`, which control the active session and are reset separately.
 *
 * Both the logout cleanup (`use-logout.ts`) and the re-login backstop
 * (`cacheInvalidationMiddleware.ts`) iterate this list and call
 * `resetApiState()` so no user's cached data leaks into the next session.
 *
 * IMPORTANT: when adding a new API slice to `store.ts`, add it here too so it
 * gets cleared when the user changes.
 */
export const userDataApis = [
  accountAccessApi,
  accountsApi,
  accountSetupApi,
  adminInvestorsApi,
  advisorAggregatedHoldingsApi,
  advisorGroupModuleLocalizationsApi,
  advisorGroupsApi,
  advisorInvestorsApi,
  aggregatedAccountsApi,
  aggregatorCredentialsApi,
  cashFlowApi,
  classificationsApi,
  clientActivityApi,
  clientsApi,
  colorsApi,
  contactsApi,
  dashboardApi,
  dashboardMessagesApi,
  dataFeedsApi,
  disclaimersApi,
  diversificationsApi,
  documentsApi,
  eConsentConfigApi,
  clientInvitationConfigApi,
  clientRelationshipsApi,
  errorsApi,
  feedClassificationsApi,
  financialInstitutionsApi,
  firmApi,
  gridColumnsApi,
  holdingsApi,
  homeAwayInstitutionsApi,
  insightsApi,
  integrationsApi,
  masterSearchApi,
  mgpApi,
  notificationsApi,
  pageVisibilityApi,
  performanceReportsApi,
  permissionsApi,
  propertyApi,
  quickLinksResourcesApi,
  reportsApi,
  settingsApi,
  setupAccountsApi,
  socialSettingsApi,
  tabsApi,
  teamMembersApi,
  termsApi,
  teamMemberApi,
  transactionsApi,
  usersApi,
  wealthsApi,
  yodleeApi,
] as const;
